import './ControlsPlayerMovie.scss'
import { formatTime } from "../../../Util/format_date";
import { useRouter } from "../../../../hooks/router";
import { useEffect, useState } from "react";

import icon_back from '../../../SubUsers/images/back-button.png'
import icon_prev from '../images/prev_skip.png'
import icon_next from '../images/next_skip.png'
import icon_episodes from '../images/restore.png'
import icon_similar from '../../../Header/images/watch_now.png'
import icon_settings from '../../../NavBar/images/settings.png'
import icon_full_screen from '../images/full-screen.png'
import icon_small_screen from '../images/full-screen_.png'
import icon_play from '../images/play.png'

import PopUpEpisodes from "./PopUpEpisodes/PopUpEpisodes";
import SubDub from './Sub_Dub/SubDub'
import SimilarContent from "./SimilarContent/SimilarContent";
import { translateWord } from "../../../Util/util";

export default function ControlsPlayerMovie({
    playPause, btn_play_pause,
    change_handle_range, valueProgress,
    fullScreen, btn_full_screen,
    currentTime, duration,
    btn_back_forward, btn_forward,
    movie, episode, valProgressNextEpisode,
    audioTracks, subtitles,
    activeAudioTrack, activeSub,
    btn_subtitle, btn_dubbing,
    btn_next_episode, btn_previous_episode
}) {
    const router = useRouter()

    const [showEpisodesField, setShowEpisodesField] = useState(false)
    const [showSubDub, setShowSubDub] = useState(false)
    const [showSimilarContent, setShowSimilarContent] = useState(false)
    const [audioTrack, setAudioTrack] = useState({})
    const [subTrack, setSubTrack] = useState({})

    const stl_movie = {
        margin: '0 .5rem'
    }

    useEffect(() => {
        let aTrack = audioTracks[activeAudioTrack]
        if (activeSub != -1) {
            let sTrack = subtitles[activeSub]
            setSubTrack({ ...sTrack })
        }
        setAudioTrack({ ...aTrack })
    }, [activeAudioTrack, activeSub, audioTracks, subtitles])

    const btn_show_episodes_field = () => {
        setTimeout(() => {
            setShowEpisodesField(!showEpisodesField)
        }, 200)
    }
    const btn_show_sub_dub_field = () => {
        setTimeout(() => {
            setShowSubDub(!showSubDub)
        }, 200)
    }
    const btn_show_similar_content = () => {
        setTimeout(() => {
            setShowSimilarContent(!showSimilarContent)
        }, 200)
    }

    const stop_propogation = (e) => {
        e.stopPropagation()
    }
    return (
        <>
            {
                showEpisodesField ?
                    <PopUpEpisodes
                        btn_show_episodes_field={btn_show_episodes_field}
                        movie={movie}
                        stop_propogation={stop_propogation}
                    />
                    : null
            }
            {
                showSubDub ?
                    <SubDub
                        btn_show_sub_dub_field={btn_show_sub_dub_field}
                        btn_subtitle={btn_subtitle}
                        btn_dubbing={btn_dubbing}
                        activeAudioTrack={activeAudioTrack}
                        activeSub={activeSub}
                        audioTracks={audioTracks}
                        subtitles={subtitles}
                        stop_propogation={stop_propogation}
                    />
                    : null
            }
            {
                showSimilarContent ?
                    <SimilarContent
                        btn_show_similar_content={btn_show_similar_content} stop_propogation={stop_propogation}
                    />
                    : null
            }
            <div className="movie_player_top_controls">
                <div className="container_player">
                    <div className="top_controls_movie">

                        <img onClick={() => router.history.goBack()} src={!fullScreen ? icon_back : ''}
                            style={{ pointerEvents: fullScreen ? "none" : "all" }} alt="" />
                        <div className="name_movie">
                            {movie.type == 'movie' ?
                                <h1>{movie.movie_translation ? (movie.movie_translation.name || movie.name) : movie.name}</h1>
                                :
                                <>
                                    <h1>{movie.movie_translation ? (movie.movie_translation.name || movie.name) : movie.name}</h1>
                                    <h3>S{router.query.season}:E{router.query.episode} - {episode.name}</h3>
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>
            <div className="movie_player_middle_controls"
                style={movie.type == 'movie' ? { justifyContent: 'center' } : null}>
                {movie.type != 'movie' ?
                    <div className="btns_mid_controls btn_prev_player" onClick={btn_previous_episode} onDoubleClick={e => e.stopPropagation()}>
                        <div className={'icon_control_player'}></div>
                    </div>
                    : null}
                <div className="btns_mid_controls btn_back_forward" onClick={btn_back_forward} onDoubleClick={e => e.stopPropagation()}
                    style={movie.type == 'movie' ? stl_movie : null}>
                    <div className={'icon_control_player'}></div>
                </div>
                <div className="btns_mid_controls btn_play" onClick={btn_play_pause} onDoubleClick={e => e.stopPropagation()}
                    style={movie.type == 'movie' ? stl_movie : null}>
                    <div
                        className={`${playPause ? 'icon_control_player_play' : 'icon_control_player_pause'} icon_control_player`}></div>
                </div>
                <div className="btns_mid_controls btn_forward" onClick={btn_forward} onDoubleClick={e => e.stopPropagation()}
                    style={movie.type == 'movie' ? stl_movie : null}>
                    <div className={'icon_control_player'}></div>
                </div>
                {movie.type != 'movie' ?
                    <div className="btns_mid_controls btn_next_player" onClick={btn_next_episode} onDoubleClick={e => e.stopPropagation()}>
                        <div className={'icon_control_player'}></div>
                    </div>
                    : null}

            </div>
            <div className="movie_player_bottom_controls">
                <div className="container_player par_bot_controls">
                    <div className="progress_field">
                        {
                            duration - currentTime < 60 && router.query.type == 'tv_show' ?

                                <div className="next_episode_progress_btn" id={'next_episode'}
                                    onClick={btn_next_episode}>
                                    <div className="progress_bar_next_episode_btn"
                                        style={{ width: `${valProgressNextEpisode}%` }}></div>
                                    <div className="inner_btn_next_episode">
                                        <img src={icon_play} alt="" />
                                        <span>{translateWord('Next Episode')}</span>
                                    </div>
                                </div>

                                : null
                        }
                        <div className="current_time_player">{formatTime(currentTime)}</div>
                        <div className="progress_player">
                            <input
                                type="range"
                                value={valueProgress}
                                onChange={change_handle_range}
                                onDoubleClick={e => e.stopPropagation()}
                                style={{ background: `linear-gradient(to right, #AFAFAF 0%, #AFAFAF ${valueProgress}%, #5E5E5E ${valueProgress}%, #5E5E5E 100%)` }}
                            />
                        </div>
                        <div className="duration_player"> {formatTime(duration)}</div>
                    </div>

                    <div className="btns_bottom_controls_player">
                        {movie.type != 'movie' ?
                            <div className="btn_bottom_controls_player next_prev_btns">
                                <img src={icon_prev} alt="" />
                                <span>{translateWord('Prev Ep')}</span>
                            </div>
                            : null}
                        <div className="btn_bottom_controls_player" onClick={btn_show_sub_dub_field} onDoubleClick={e => e.stopPropagation()}>
                            <img src={icon_settings} alt="" />
                            {/* <span>{audioTrack.name} + {activeSub == -1 ? 'Off' : subTrack.name} {activeSub == -1 ? null : 'sub.'}</span> */}
                            <span>{translateWord('Audio(Dubbing) + Subtitles')}</span>
                        </div>
                        {movie.type != 'movie' ?
                            <div className="btn_bottom_controls_player" onClick={btn_show_episodes_field} onDoubleClick={e => e.stopPropagation()}>
                                <img src={icon_episodes} alt="" />
                                <span>{translateWord('Episodes')}</span>
                            </div>
                            : null}
                        <div className="btn_bottom_controls_player" onClick={btn_show_similar_content} onDoubleClick={e => e.stopPropagation()}>
                            <img src={icon_similar} alt="" />
                            <span>{translateWord('Similar Content')}</span>
                        </div>
                        {movie.type != 'movie' ?
                            <div className="btn_bottom_controls_player next_prev_btns" onClick={btn_next_episode} onDoubleClick={e => e.stopPropagation()}>
                                <img src={icon_next} alt="" />
                                <span>{translateWord('Next Ep')}</span>
                            </div>
                            : null}
                    </div>
                </div>
                <div className="full_screen_btn" onClick={btn_full_screen} onDoubleClick={e => e.stopPropagation()}>
                    <img src={fullScreen ? icon_small_screen : icon_full_screen} alt="" />
                </div>
            </div>
        </>
    )
}